// React for Website

import React from "react";
//outsource
import { Radio, Form } from "antd";

//components

const StaffStatus = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  const status = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="active">
      <Radio.Group
        options={status}
        optionType="button"
        buttonStyle="solid"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default StaffStatus;
